module.exports = __webpack_public_path__ + "img/hair_front_female_left_part_mask.43320cc7.png";